import { type Dayjs } from 'dayjs';
import { useCallback, useMemo } from 'react';
import { useConfigs } from 'shared/src/queries';
import { isNil } from 'shared/src/utils';

export const useGetNextArrivalDay = (
  date: Dayjs | null,
  deliveryType?: 'today' | 'shak' | 'standard' | 'reserved',
) => {
  const { data: configs } = useConfigs();

  const holidays = useMemo<{ [key: string]: boolean }>(() => {
    const list = [...(configs?.delivery_holidays ?? [])];
    if (deliveryType === 'shak') {
      list.push(...(configs?.shak_delivery.holidays ?? []));
    }
    return list.reduce<{ [key: string]: boolean }>((acc, cur) => {
      acc[cur] = true;
      return acc;
    }, {});
  }, [configs?.delivery_holidays, configs?.shak_delivery.holidays, deliveryType]);

  // 월~토 영업일 기준 (단, 토요일이 공휴일인 경우 제외)
  const isBusinessDay = useCallback(
    (day: Dayjs) => {
      const dayOfWeek = day.day();
      const dateKey = day.format('YYYY-MM-DD');
      // 일요일 제외
      if (dayOfWeek === 0) return false;
      // 공휴일 제외 (토요일이 공휴일인 경우도 포함)
      return !holidays[dateKey];
    },
    [holidays],
  );

  return useMemo(() => {
    if (isNil(date)) return null;

    let current = date;
    // 다음 영업일을 찾을 때까지 반복
    do {
      current = current.add(1, 'day');
    } while (!isBusinessDay(current));

    return current;
  }, [date, isBusinessDay]);
};